import React, { useEffect, useState } from 'react'
import { t } from '../../i18n'

const scope = 'orders'

const RefreshControl = ({ onRefresh, isFetching, lastUpdatedAt, hasError }: {
  onRefresh: () => void
  isFetching: boolean
  lastUpdatedAt: number | null
  hasError: boolean
}) => {
  const [secondsAgo, setSecondsAgo] = useState<number | null>(null)

  useEffect(() => {
    if (lastUpdatedAt === null) {
      setSecondsAgo(null)
      return
    }

    const update = () => setSecondsAgo(Math.round((Date.now() - lastUpdatedAt) / 1000))
    update()
    const id = setInterval(update, 1000)
    return () => clearInterval(id)
  }, [lastUpdatedAt])

  return (
    <div className='orders-refresh d-flex align-items-center'>
      <button
        type='button'
        className='btn bw-button orders-refresh__button d-flex align-items-center'
        onClick={onRefresh}
        disabled={isFetching}
      >
        <i className={`fa fa-refresh${isFetching ? ' fa-spin' : ''}`} />
        <span className='ms-1'>{isFetching ? t('updating', { scope }) : t('refresh', { scope })}</span>
      </button>
      {hasError
        ? <span className='orders-refresh__status text-danger ms-3'>{t('update_failed', { scope })}</span>
        : secondsAgo !== null &&
          <span className='orders-refresh__status text-muted ms-3'>
            {t('last_updated', { scope, seconds: secondsAgo })}
          </span>
      }
    </div>
  )
}

export default RefreshControl
